import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../../components/product/ProductCard";

const FeaturedProducts = ({ products }) => {
  return (
    <section className="py-8 px-4">
      <div className="mb-6 text-center">
        <h2 className="text-2xl font-bold">Featured Products</h2>
        <Link to="/products" className="text-blue-600 hover:text-blue-800">
          View all Products
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products?.map((product, index) => (
          <ProductCard key={index} product={product} />       
        ))}
      </div>
    </section>
  );
};

export default FeaturedProducts;
